import { api } from './client'

/** R3-28 (REQ-260-001): client di `GET/PUT /api/agents/me` e delle richieste di modifica IBAN. */
export type BankChangeStatus = 'pending' | 'approved' | 'rejected'

export interface MyBankChange {
  id: number
  status: BankChangeStatus
  requestedAt: string
  newIbanMasked: string | null
  decidedAt: string | null
  decisionNote: string | null
}

export interface MyAgentProfile {
  id: number
  code: string | null
  isActive: boolean
  ibanMasked: string | null
  pendingBankChange: MyBankChange | null
  lastBankChange: MyBankChange | null
}

export interface BankChangeRequestRow {
  id: number
  agentProfileId: number
  userId: number
  agentCode: string | null
  status: BankChangeStatus
  requestedAt: string
  currentIbanMasked: string | null
  newIbanMasked: string | null
  decidedAt: string | null
  decisionNote: string | null
}

export const agentSelfApi = {
  me: () => api<MyAgentProfile>('/api/agents/me'),
  requestIbanChange: (iban: string) =>
    api<{ id: number; status: BankChangeStatus }>('/api/agents/me', { method: 'PUT', body: JSON.stringify({ iban }) }),
  listRequests: (status: BankChangeStatus = 'pending') =>
    api<BankChangeRequestRow[]>(`/api/agents/bank-change-requests?status=${status}`),
  approve: (id: number, note?: string) =>
    api<void>(`/api/agents/bank-change-requests/${id}/approve`, { method: 'POST', body: JSON.stringify({ note }) }),
  reject: (id: number, note?: string) =>
    api<void>(`/api/agents/bank-change-requests/${id}/reject`, { method: 'POST', body: JSON.stringify({ note }) }),
}
